'use client'

import { Builder } from '@builder.io/react'

import { TopNav } from './TopNav'
import { defaultTopNavProps } from './TopNav.defaults'

const linkSubFields = [
  {
    name: 'title',
    type: 'text',
  },
  {
    name: 'href',
    type: 'text',
  },
  {
    name: 'newTab',
    friendlyName: 'open in a new tab',
    type: 'boolean',
  },
]

Builder.registerComponent(TopNav, {
  name: 'TopNav',
  hideFromInsertMenu: true,
  inputs: [
    {
      name: 'logo',
      type: 'object',
      subFields: [
        {
          name: 'src',
          type: 'file',
          friendlyName: 'Logo image',
        },
        {
          name: 'href',
          type: 'string',
          friendlyName: 'Logo link',
        },
        {
          name: 'altText',
          type: 'string',
          friendlyName: 'Logo image alt text',
        },
        {
          name: 'desktopWidth',
          type: 'number',
        },
        {
          name: 'desktopHeight',
          type: 'number',
        },
        {
          name: 'mobileWidth',
          type: 'number',
        },
        {
          name: 'mobileHeight',
          type: 'number',
        },
      ],
      defaultValue: defaultTopNavProps.logo,
    },
    {
      name: 'links',
      type: 'object',
      subFields: [
        {
          name: 'signUp',
          type: 'object',
          subFields: [...linkSubFields],
        },
        {
          name: 'logIn',
          type: 'object',
          subFields: [...linkSubFields],
        },
      ],
      defaultValue: defaultTopNavProps.links,
    },
    {
      name: 'menus',
      type: 'list',
      subFields: [
        {
          name: 'title',
          type: 'string',
        },
        {
          name: 'hasFeaturedItemMobile',
          type: 'boolean',
        },
        {
          name: 'featuredItemMobile',
          showIf: `options.get('hasFeaturedItemMobile') === true`,
          type: 'object',
          subFields: [...linkSubFields],
        },
        {
          name: 'hasFeaturedItemDesktop',
          type: 'boolean',
        },
        {
          name: 'featuredItemDesktop',
          showIf: `options.get('hasFeaturedItemDesktop') === true`,
          type: 'object',
          subFields: [...linkSubFields],
        },
        {
          name: 'hasDropdown',
          type: 'boolean',
        },
        {
          name: 'items',
          type: 'list',
          showIf: `options.get('hasDropdown') === true`,
          subFields: [...linkSubFields],
        },
        {
          name: 'href',
          type: 'string',
          showIf: `options.get('hasDropdown') === false`,
        },
        {
          name: 'newTab',
          friendlyName: 'open in a new tab',
          type: 'boolean',
          showIf: `options.get('hasDropdown') === false`,
        },
      ],
      defaultValue: defaultTopNavProps.menus,
    },
    {
      name: 'mobileFooterLinks',
      type: 'list',
      subFields: [...linkSubFields],
      defaultValue: defaultTopNavProps.mobileFooterLinks,
    },
  ],
  image: 'https://unpkg.com/@tabler/icons@2.44.0/icons/layout-navbar.svg',
})
